const words = [
  "Post Production",
  "★",
  "Distribution",
  "★",
  "Short Form Clips",
  "★",
  "Thumbnails",
  "★",
  "LinkedIn Posts",
  "★",
  "X Threads",
  "★",
  "Newsletters",
  "★",
  "Blog Posts",
  "★",
  "Show Notes",
  "★",
  "Transcripts",
  "★",
  "Guest Promos",
  "★",
];

export default function Marquee() {
  const items = [...words, ...words];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-[#222] bg-[#070707] overflow-hidden py-6 md:py-8"
    >
      <div className="marquee-track flex items-center gap-12 whitespace-nowrap">
        {items.map((w, i) => (
          <span
            key={i}
            className={`font-display text-xl md:text-3xl uppercase tracking-tight ${
              w === "★" ? "text-[#F4C75E]" : "text-[#F5F5F5]"
            }`}
          >
            {w}
          </span>
        ))}
      </div>
    </div>
  );
}
